"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/* eslint max-len:0 */

/**
 * YouTubeIcon Return the youtube icon as a functional Component
 *
 * @param {String} altText for svg alt
 * @returns {Function} icon svg
 * @public
 */
function YouTubeIcon(_ref) {
  let {
    altText
  } = _ref;
  // eslint-disable-next-line max-len
  return /*#__PURE__*/_react.default.createElement("svg", {
    role: "img",
    "aria-label": altText,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("title", {
    id: altText
  }, altText), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.58 7.15a2.51 2.51 0 0 0-1.77-1.77C18.25 5 12 5 12 5s-6.25 0-7.81.43a2.51 2.51 0 0 0-1.77 1.72A26.28 26.28 0 0 0 2 12a26.28 26.28 0 0 0 .42 4.85 2.51 2.51 0 0 0 1.77 1.77c1.56.43 7.81.43 7.81.43s6.25 0 7.81-.43a2.51 2.51 0 0 0 1.77-1.77A26.28 26.28 0 0 0 22 12a26.28 26.28 0 0 0-.42-4.85zM10 15V9l5.23 3z"
  }));
}
YouTubeIcon.propTypes = {
  altText: _propTypes.default.string.isRequired
};
var _default = YouTubeIcon;
exports.default = _default;